export default __webpack_public_path__ + "static/media/housing.9c9414fe.jpeg";